import React, { useState, useEffect } from "react";
import MarketTableSingle from "../../../components/market-tables/MarketTableSingle.js";
import TopicTwo from "../../../components/trading-contents/standard-accounts-contents/TopicTwo";

const MarketTable = () => {
  // 1. Initialize state to hold the live data
  const [marketData, setMarketData] = useState([]);

  // 2. Fetch data when component mounts
  useEffect(() => {
    const fetchLivePrices = async () => {
      try {
        // IDs of the coins you had in your original list
        const coinIds = "bitcoin,ethereum,ripple,bitcoin-cash,cardano,litecoin,stellar,iota";
        
        // Fetching 7-day change specifically to match your table header "%7day"
        const response = await fetch(
          `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&ids=${coinIds}&order=market_cap_desc&sparkline=false&price_change_percentage=7d`
        );
        
        const data = await response.json();

        // 3. Map API data to your specific App structure
        const formattedData = data.map((coin, index) => ({
          id: (index + 1).toString(),
          image: coin.image,
          symbol: `${coin.name} (${coin.symbol.toUpperCase()})`,
          price: coin.current_price,
          volume: coin.total_volume,
          // Uses 7d change if available (to match your header), falls back to 24h
          percent: coin.price_change_percentage_7d_in_currency || coin.price_change_percentage_24h 
        }));

        setMarketData(formattedData);
      } catch (error) {
        console.error("Error fetching crypto data:", error);
      }
    };

    fetchLivePrices();
  }, []);

  return (
    <>
      <TopicTwo />

      <div className="market__table bg--white">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 table-responsive">
              <table className="mkt__pre__list">
                <thead>
                  <tr>
                    <th className="market-no">
                      <span className="nobr">#No</span>
                    </th>
                    <th className="market-symbol">Name &amp; Symbol</th>
                    <th className="market-prize">
                      <span className="nobr">Price</span>
                    </th>
                    <th className="market-volume">
                      <span className="nobr">Volume</span>
                    </th>
                    <th className="market-dat">
                      <span className="nobr">%7day</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* Check if data exists, then map */}
                  {marketData && marketData.length > 0 ? (
                    marketData.map((single, key) => {
                      return <MarketTableSingle data={single} key={key} />;
                    })
                  ) : (
                    // Optional: Simple loading state
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                        Loading Live Data...
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketTable;